import Register from "@/components/register";

export default function HomePage() {
  return (
    <div className="bg-[#F9FAFC] p-6 min-h-screen">
      <Register />
    </div>
  );
}
